import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { savedConfigurationsPageQueryOptions } from "~/app/api/pageData/savedConfigurationsPageQuery";
import type { SavedConfigurationsPageInitialData } from "~/app/api/pageData/savedConfigurationsPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createSavedConfigurationsPage } from "~/pages/SavedConfigurationsPage/SavedConfigurationsPage";

function SavedConfigurationsRoute() {
  const result = useLoaderData({
    from: "/saved-configs",
  }) as PageInitialData<SavedConfigurationsPageInitialData>;
  const shellProps = useStorefrontShellProps();
  const savedConfigurations = result.data?.savedConfigurations ?? [];

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createSavedConfigurationsPage(savedConfigurations)}
    </StorefrontShellFrame>
  );
}

export async function loadSavedConfigurationsPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(savedConfigurationsPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const savedConfigurationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/saved-configs",
  loader: async ({ context }) => loadSavedConfigurationsPageData(context),
  component: SavedConfigurationsRoute,
});
